import { select_virtel_where_parent_subkey } from "./frfr-virtel-selectors";


// VIRBOM REVERSE/BIDIRECTIONAL TRAVERSING
/*
FrFr FRIENDLY FRAMEWORK
frfr-virbom-bidirectional-traversing-utils
Version ID: 1a 2024-04-01r1
by 
// Please describe here if you customized this file
*/


export const _virbom_bidirectional_traversing_update = (virbom_seq, _own_data_creator, _make_new_obj_children_collected_data, _collector, _combine_own_and_children_collected_data, _virtel_updater) => {
  console.log('***** VIRBOM REVERSE TRAVERSING *****');
  let _vs = [];
  if (Array.isArray(virbom_seq)) {
    _vs = virbom_seq.map((v) => {
      return { ...v };
    }); // PURE CLONE OF virbom_seq
  }
  // console.log(_vs);

  // --- INTERNAL UTILS
  const _dirty_update = (virtel_index, updated_virtel) => {
    _vs[virtel_index] = updated_virtel;
  };

  const _get_index_of_virtel = (subkey) => {
    let vindex = false;
    _vs.forEach((item, index) => {
      if (item.subkey === subkey) {
        vindex = index;
      }
    });
    return vindex;
  };


  // --- ITERATOR TRAVERSER SINGE - ITEM
  const _tree_virtel_single = (virtel, this_graphlevel, _cb_for_me, ref_sibling_collected_data, parent_data) => {

    // -----NORMAL TRAVERSING DIRECTION----- od parent prema children

    // KORAK OWN
    // console.log('virtel');
    // console.log(virtel);
    const own_data = _own_data_creator(virtel, parent_data);
    // console.log('own_data');
    // console.log(own_data);

    // KORAK pred spustanje na children nivo
    const ref_children_collected_data = _make_new_obj_children_collected_data(); // new object
    // console.log('ref_children_collected_data');
    // console.log(ref_children_collected_data);

    const _cb_for_children = (child_data, ref_children_collected_data) => {
      // DIRTY UPDATE ref_children_collected_data
      _collector(child_data, ref_children_collected_data); // every child will merge self data with their sibling data
    };

    // KORAK CHILDREN - pozivanje iteracija za children elemente
    const parent_subkey = virtel.subkey;
    const children_virtel_arr = select_virtel_where_parent_subkey(virbom_seq, parent_subkey);
    // console.log('children');
    // console.log(children_virtel_arr);
    // spustanje na children granu
    if (children_virtel_arr.length > 0) {
      // postoji niza grana sa jos children
      const target_graphlevel = this_graphlevel + 1;
      _tree_virtel_each(children_virtel_arr, target_graphlevel, _cb_for_children, ref_children_collected_data, own_data);
    } else {
      // nema children na nizoj grani
    }
    // Bez obzira da li ima ili nema children prethodna if petlja nista ne menja samo je optimizovanije sa njom.


    // -----REVERSE TRAVERSING DIRECTION-----
    // REVERSE ZNACI U SMERU OD CHILDREN PREMA PARENTU

    // nakon sto je zavrsio sa childrenima
    // console.log('ref_children_collected_data');
    // console.log(ref_children_collected_data);


    // KORAK COMBINE OWN AND CHILDREN DATA
    const combined_data = _combine_own_and_children_collected_data(own_data, ref_children_collected_data);
    // console.log('combined_data');
    // console.log(combined_data);


    // --- KORAK SLANJE PODATAKA PARENTU
    if (typeof _cb_for_me === 'function' && ref_sibling_collected_data) {
      // na ovaj callback saljemo parent-u vreme kumulativno i vreme_ugradnje_u_parent
      _cb_for_me(combined_data, ref_sibling_collected_data);
    } else {
      // graphlevel 1 - prvi nivo zovemo bez callbacka
      // sta se tada desava??? verovatno ne treba nista za graphlevel 1 jer on nema parent i nema kome da salje svoju vrednost.
    }


    // KORAK UPDATE VIRTEL
    const updated_virtel = _virtel_updater(virtel, combined_data);
    // console.log(updated_virtel);

    // KORAK FAZA DORADE virbom_seq - DIRTY UPDATE virbom_seq-a
    let virtel_index = _get_index_of_virtel(virtel.subkey);
    _dirty_update(virtel_index, updated_virtel);
  };

  // --- ITERATOR TRAVERSER MULTI - FOREACH ITEM
  const _tree_virtel_each = (_virtelArr, target_graphlevel, _cb, ref_children_collected_data, parent_data) => {
    _virtelArr.forEach((virtel) => {
      // console.log('each');
      // console.log(virtel);
      if (virtel.graphlevel === target_graphlevel) {
        _tree_virtel_single(virtel, target_graphlevel, _cb, ref_children_collected_data, parent_data);
      }
    });
  };

  // --- STARTOVANJE iteracija i updatea _____ pocev od level 1
  _tree_virtel_each(virbom_seq, 1, null, null, null); // nivo 1 pozivamo bez callbacka. On ce sam da daje childrenima 

  // --- ZAVRSENO, vracamo updated virbom_seq sa popunjenim kumulativnim vremenima
  return _vs;
};

